import { event } from '@abyss/web/tools/event';

export const adobeSubpageTrackEvent = (input: { contentSection: string }) => {
  event('SUBPAGE_TRACK_EVENT', {
    subpage: {
      contentSection: input.contentSection?.toLowerCase(),
    },
  });
};
